import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-1",
  "use": "icon-arrow-1-usage",
  "viewBox": "0 0 8.59 12.94",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8.59 12.94\" id=\"icon-arrow-1\"><defs><style>#icon-arrow-1 .cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:3px;}</style></defs><g id=\"icon-arrow-1_圖層_2\" data-name=\"圖層 2\"><g id=\"icon-arrow-1_圖層_1-2\" data-name=\"圖層 1\"><polyline class=\"cls-1\" points=\"1.06 1.06 6.47 6.47 1.06 11.88\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol